export const SAVE_RELTAD_LIST = 'SAVE_RELTAD_LIST';
export const saveRelatedList = (data) => ({
  type: SAVE_RELTAD_LIST,
  data,
});
